import React, { useState, useEffect } from 'react';

// Global reference to the addToast function
let addToastFn = null;

export const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);
    
    useEffect(() => {
        addToastFn = (message, type = 'success') => {
            const id = Date.now() + Math.random();
            setToasts(prev => [...prev, { id, message, type }]);
            
            // Auto-remove after 3 seconds
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id !== id));
            }, 3000);
        };

        return () => {
            addToastFn = null;
        };
    }, []);

    return (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[999999] flex flex-col gap-3 pointer-events-none">
            {toasts.map(t => (
                <div 
                    key={t.id} 
                    className={`px-6 py-3 rounded-xl shadow-2xl text-white font-semibold text-sm transition-all duration-300 transform translate-y-0 opacity-100 ${
                        t.type === 'error' ? 'bg-red-600' : 
                        t.type === 'warning' ? 'bg-amber-500' : 
                        t.type === 'info' ? 'bg-blue-500' : 
                        'bg-emerald-600'
                    }`}
                >
                    {t.message}
                </div>
            ))}
        </div>
    );
};

export const toast = {
    success: (msg) => {
        if (addToastFn) addToastFn(msg, 'success');
        else console.log("SUCCESS:", msg);
    },
    error: (msg) => {
        if (addToastFn) addToastFn(msg, 'error');
        else console.log("ERROR:", msg);
    },
    info: (msg) => {
        if (addToastFn) addToastFn(msg, 'info');
        else console.log("INFO:", msg);
    },
    warning: (msg) => {
        if (addToastFn) addToastFn(msg, 'warning');
        else console.log("WARNING:", msg);
    }
};
